import { Ability } from "@/interfaces/ability";
import axios from "@/lib/axios";
import { useAbilitiesStore } from "@/stores/abilities";
import { useQuery } from "@tanstack/vue-query";
import { storeToRefs } from "pinia";
import { watch } from "vue";

const getAbilities = async () => {
  const { data } = await axios.get<Ability[]>("api/abilities");

  return data;
};

const useAbilities = () => {
  const { setAbilities } = useAbilitiesStore();
  const { abilities } = storeToRefs(useAbilitiesStore());

  const { data, error, isLoading } = useQuery({
    queryKey: ["abilities"],
    queryFn: getAbilities,
    enabled: true,
  });

  watch(data, (value) => {
    if (value) {
      setAbilities(value);
    }
  });

  return {
    abilities,
    error,
    isLoading,
  };
};

export default useAbilities;
